import { render, staticRenderFns } from "./YouSure.vue?vue&type=template&id=b21a8f38&"
import script from "./YouSure.vue?vue&type=script&lang=js&"
export * from "./YouSure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports